// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as NavMenu__Content$Showside from "../components/NavMenu/NavMenu__Content.bs.js";
import * as NavMenu__Context$Showside from "../components/NavMenu/NavMenu__Context.bs.js";
import * as NavMenu__Transition$Showside from "../components/NavMenu/NavMenu__Transition.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as NavMenu__IndexContent$Showside from "../components/NavMenu/NavMenu__IndexContent.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "./QuickViewOverlay_Lazy.bs.js";
import * as NavMenu__ModalContainer$Showside from "../components/NavMenu/NavMenu__ModalContainer.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "./ProductDetailsPage_Lazy.bs.js";
function NavMenuOverlay$Items(Props) {
  var activeValue = Props.activeValue;
  var match = ConfigurationProvider$Showside.use(undefined);
  RouterProvider$Showside.useRouter(undefined);
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match$1 = React.useState(function () {
    return ctx.isModalOpen;
  });
  var setEverBeenOpen = match$1[1];
  var hasEverBeenOpen = match$1[0];
  React.useEffect(function () {
    Curry._1(setEverBeenOpen, function (previous) {
      if (previous) {
        return true;
      } else {
        return ctx.isModalOpen;
      }
    });
  }, [ctx.isModalOpen]);
  return Belt_Array.mapWithIndex(Belt_Array.keepWithIndex(match.config.categories, function (category, value) {
    if (value === activeValue) {
      return true;
    } else {
      return hasEverBeenOpen;
    }
  }), function (value, category) {
    return React.createElement(NavMenu__Transition$Showside.Content.make, {
      value: value,
      dataTestId: "nav-menu-content-l1",
      className: CSS$Showside.prefix("h-full"),
      children: Category$Showside.isIndexNode(category) ? React.createElement(NavMenu__IndexContent$Showside.make, {
        disabled: value !== activeValue,
        category: category
      }) : React.createElement(NavMenu__Content$Showside.make, {
        level: 1,
        category: category,
        disabled: value !== activeValue
      }),
      key: category.id
    });
  });
}
NavMenuOverlay$Items.displayName = "NavMenuOverlay.Items";
var make = React.memo(NavMenuOverlay$Items);
var Items = {
  make: make
};
function NavMenuOverlay(Props) {
  var contentHeight = Props.contentHeight;
  var setContentHeight = Props.setContentHeight;
  var onMouseLeave = Props.onMouseLeave;
  var onMouseEnter = Props.onMouseEnter;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var quickViewUnderlyingRoute = match$1.quickViewUnderlyingRoute;
  var route = match$1.route;
  var handleResize = React.useCallback(function (width) {
    return function (height) {
      return Curry._1(setContentHeight, function (param) {
        return height;
      });
    };
  }, [setContentHeight]);
  var activeValue = React.useMemo(function () {
    return Belt_Option.map(ctx.currentL1, function (category) {
      return config.categories.indexOf(category);
    });
  }, [ctx.currentL1]);
  var previousActiveValue = Belt_Option.getWithDefault(Previous$Showside.usePreviousSome(activeValue), 0);
  var value = Belt_Option.getWithDefault(activeValue, previousActiveValue);
  React.useEffect(function () {
    var preload = function (param) {
      Curry._1(ProductDetailsPage_Lazy$Showside.preload, undefined);
      return Curry._1(QuickViewOverlay_Lazy$Showside.preload, undefined);
    };
    window.addEventListener("mousemove", preload);
    return function (param) {
      window.removeEventListener("mousemove", preload);
    };
  }, []);
  var tmp = {
    contentHeight: contentHeight,
    children: React.createElement(NavMenu__Transition$Showside.Container.make, {
      value: value,
      direction: activeValue === undefined ? /* NoMotion */2 : /* Horizontal */1,
      animate: true,
      children: React.createElement(make, {
        activeValue: value,
        contentHeight: contentHeight,
        onItemResize: handleResize
      })
    })
  };
  if (activeValue !== undefined) {
    tmp.activeValue = activeValue;
  }
  if (onMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(onMouseLeave);
  }
  if (onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(onMouseEnter);
  }
  var tmp$1;
  var exit = 0;
  var exit$1 = 0;
  if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */2)) {
    exit = 1;
  } else {
    exit$1 = 2;
  }
  if (exit$1 === 2) {
    if (typeof route === "number" || route.TAG !== /* PDP */2) {
      tmp$1 = null;
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp$1 = React.createElement(ProductDetailsPage_Lazy$Showside.make, {});
  }
  var tmp$2;
  tmp$2 = typeof route === "number" || route.TAG !== /* QuickView */3 ? null : React.createElement(QuickViewOverlay_Lazy$Showside.make, {});
  return React.createElement(ErrorBoundary$Showside.make, {
    componentName: "NavMenuOverlay",
    children: null
  }, React.createElement(NavMenu__ModalContainer$Showside.make, tmp), tmp$1, tmp$2);
}
NavMenuOverlay.displayName = "NavMenuOverlay";
var make$1 = React.memo(NavMenuOverlay);
var $$default = make$1;
export { Items, make$1 as make, $$default, $$default as default };
/* make Not a pure module */